// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getDevices as listDevicesAPI,
    getPlayers as listPlayersAPI,
    getInteractives as listInteractivesAPI,
    getDevice as getDeviceAPI,
    addDevice as addDeviceAPI,
    updateDevice as updateDeviceAPI,
    deleteDevice as deleteDeviceAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { devicesApiResponseError, devicesApiResponseSuccess } from './actions';
import { DevicesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get device
 * @param {*} payload - device id
 */
function* getDevice({ payload: { id } }) {
    try {
        const response = yield call(getDeviceAPI, id );
        const deviceItem = response.data.data;
        yield put(devicesApiResponseSuccess(DevicesActionTypes.GET_DEVICE, deviceItem));
    } catch (error) {
        yield put(devicesApiResponseError(DevicesActionTypes.GET_DEVICE, error));
    }
}

function* addDevice({payload:device}){
    try{
        const response = yield call(addDeviceAPI,{...device})
        const deviceItem = response.data.data
        yield put(devicesApiResponseSuccess(DevicesActionTypes.ADD_DEVICE,deviceItem))
    } catch(error){
        yield put(devicesApiResponseError(DevicesActionTypes.ADD_DEVICE,error))
    }
}

function* updateDevice({payload:device}){
    try{
        const response = yield call(updateDeviceAPI,{...device})
        const deviceItem = response.data.data
        yield put(devicesApiResponseSuccess(DevicesActionTypes.UPDATE_DEVICE,deviceItem))
    }catch(error){
        yield put(devicesApiResponseError(DevicesActionTypes.UPDATE_DEVICE,error))
    }
}
function* deleteDevice({payload:device}){
    try{
        const response = yield call(deleteDeviceAPI,{...device})
        const deviceItem = response.data.id
        yield put(devicesApiResponseSuccess(DevicesActionTypes.DELETE_DEVICE,deviceItem))
    }catch(error){
        yield put(devicesApiResponseError(DevicesActionTypes.DELETE_DEVICE,error))
    }
}

function* listDevices({payload:params}) {
    try {
        const response = yield call(listDevicesAPI, { ...params });
        const listaDevices = response.data.data;
        yield put(devicesApiResponseSuccess(DevicesActionTypes.LIST_DEVICES, listaDevices));
    } catch (error) {
        yield put(devicesApiResponseError(DevicesActionTypes.LIST_DEVICES, error));
    }
}
function* listPlayers({payload:params}) {
    try {
        const response = yield call(listPlayersAPI, { ...params });
        const listaPlayers = response.data.data;
        yield put(devicesApiResponseSuccess(DevicesActionTypes.LIST_PLAYERS, listaPlayers));
    } catch (error) {
        yield put(devicesApiResponseError(DevicesActionTypes.LIST_PLAYERS, error));
    }
}
function* listInteractives({payload:params}) {
    try {
        const response = yield call(listInteractivesAPI, { ...params });
        const listaInteractives = response.data.data;
        yield put(devicesApiResponseSuccess(DevicesActionTypes.LIST_INTERACTIVES, listaInteractives));
    } catch (error) {
        yield put(devicesApiResponseError(DevicesActionTypes.LIST_INTERACTIVES, error));
    }
}

export function* watchGetDevice(): any {
    yield takeEvery(DevicesActionTypes.GET_DEVICE, getDevice);
}
export function* watchListDevices(): any {
    yield takeEvery(DevicesActionTypes.LIST_DEVICES, listDevices);
}
export function* watchListPlayers(): any {
    yield takeEvery(DevicesActionTypes.LIST_PLAYERS, listPlayers);
}
export function* watchListInteractives(): any {
    yield takeEvery(DevicesActionTypes.LIST_INTERACTIVES, listInteractives);
}
export function* watchAddDevice():any{
    yield takeEvery(DevicesActionTypes.ADD_DEVICE,addDevice)
}
export function* watchUpdateDevice():any{
    yield takeEvery(DevicesActionTypes.UPDATE_DEVICE,updateDevice)
}
export function* watchDeleteDevice():any{
    yield takeEvery(DevicesActionTypes.DELETE_DEVICE,deleteDevice)
}


function* devicesSaga(): any {
    yield all([
        fork(watchGetDevice),
        fork(watchListDevices),
        fork(watchListPlayers),
        fork(watchListInteractives),
        fork(watchAddDevice),
        fork(watchUpdateDevice),
        fork(watchDeleteDevice),
    ]);
}

export default devicesSaga;
